
(function () {
  /* Guard: prevent duplicate popup from multiple snippet renders */
  if (document.querySelectorAll("#csrf-popup").length > 1) {
    var dupes = document.querySelectorAll("#csrf-popup");
    dupes[dupes.length - 1].parentNode.removeChild(dupes[dupes.length - 1]);
    var overlayDupes = document.querySelectorAll("#csrf-overlay");
    if (overlayDupes.length > 1) overlayDupes[overlayDupes.length - 1].parentNode.removeChild(overlayDupes[overlayDupes.length - 1]);
  }

  var PRICE_MIN = 0;
  var PRICE_MAX = 2000;
  var _initDone = false;

  function escHtml(v) {
    return String(v || "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  window.csrFilter = {

    /* ── Open (toggle) ── */
    open: function () {
      var popup = document.getElementById("csrf-popup");
      if (popup.classList.contains("is-open")) { this.close(); return; }
      popup.classList.add("is-open");
      if (window.innerWidth < 750) {
        document.getElementById("csrf-overlay").classList.add("is-on");
        var scrollY = window.scrollY || window.pageYOffset;
        document.body.dataset.csrfScrollY = scrollY;
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.top = "-" + scrollY + "px";
      }
      this._applyFilters();
    },

    /* ── Close ── */
    close: function () {
      var popup = document.getElementById("csrf-popup");
      popup.classList.remove("is-open");
      document.getElementById("csrf-overlay").classList.remove("is-on");
      if (document.body.dataset.csrfScrollY !== undefined && document.body.style.position === "fixed") {
        var scrollY = parseInt(document.body.dataset.csrfScrollY || "0", 10);
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      }
    },

    /* ── Populate filters from API items + facets ────────────── */
    populate: function (items, facets) {
      var self = this;
      items = items || [];
      facets = facets || {};

      /* Capture the user's current selections BEFORE the lists/sliders are
         rebuilt below — populate() re-renders all checkboxes, pills and resets
         the price slider, which otherwise silently wipes an active filter set
         (e.g. when a sort re-fetch re-renders the grid). Restored at the end.
         Only preserve across re-renders of the SAME query; a brand-new search
         should start with a clean filter state. */
      var _curQuery = (new URLSearchParams(location.search).get("q") || "").trim();
      var _prevSel = (_curQuery === self._lastQuery) ? self._captureState() : null;
      self._lastQuery = _curQuery;

      var categories = {};
      var sizes      = {};
      var availIn    = 0;
      var availOut   = 0;
      var globalMinPrice = Infinity;
      var globalMaxPrice = 0;

      /* ── Build filter data from loaded product items ── */
      items.forEach(function (p) {
        var v0 = (p.variants && p.variants[0]) || {};
        var rawPrice   = parseFloat(v0.price || p.minPrice || 0);
        var rawCompare = parseFloat(v0.compareAtPrice || 0);
        if (rawPrice > 0 && rawPrice < globalMinPrice) globalMinPrice = rawPrice;
        if (rawPrice > globalMaxPrice)                  globalMaxPrice = rawPrice;
        if (rawCompare > globalMaxPrice)                globalMaxPrice = rawCompare;

        var pt = (p.productType || p.product_type || "").trim();
        if (pt) categories[pt] = (categories[pt] || 0) + 1;

        var inStock = !(p.totalInventory != null && p.totalInventory <= 0);
        if (inStock) availIn++; else availOut++;

        (p.variants || []).forEach(function (v) {
          var title = (v.title || "").trim();
          if (title && title.toLowerCase() !== "default title" && title.length <= 40) {
            sizes[title] = (sizes[title] || 0) + 1;
            return;
          }
          (v.selectedOptions || []).forEach(function (opt) {
            var optName = (opt.name || "").trim().toLowerCase();
            var val     = (opt.value || "").trim();
            if (!val || val.toLowerCase() === "default title" || optName === "title") return;
            if (val.length > 40) return;
            sizes[val] = (sizes[val] || 0) + 1;
          });
        });
      });

      /* ── Extract Gender from tags (Man, Woman, Unisex) ── */
      var GENDER_TAGS = ['Man', 'Woman', 'UNISEX', 'Unisex', 'Men', 'Women'];
      var genders = {};
      items.forEach(function (p) {
        var tags = p.tags || [];
        if (typeof tags === "string") tags = tags.split(",");
        var found = {};
        tags.forEach(function (t) {
          t = (t + "").trim();
          var lower = t.toLowerCase();
          if (lower === 'man' || lower === 'men' || lower === 'perfumes for men' || lower === 'perfume for men') {
            if (!found['Men']) { found['Men'] = true; genders['Men'] = (genders['Men'] || 0) + 1; }
          } else if (lower === 'woman' || lower === 'women' || lower === 'perfumes for her' || lower === 'perfume for women' || lower === 'women fragrances' || lower === 'womens fragrances') {
            if (!found['Women']) { found['Women'] = true; genders['Women'] = (genders['Women'] || 0) + 1; }
          } else if (lower === 'unisex' || lower === 'unisex perfumes') {
            if (!found['Unisex']) { found['Unisex'] = true; genders['Unisex'] = (genders['Unisex'] || 0) + 1; }
          }
        });
      });

      /* ── Extract Ingredient from API facets (perfume_notes) or fallback to tags ── */
      var ingredients = {};
      var apiFilters = facets.filters || [];
      var notesFacet = apiFilters.filter(function(f) { return f.key === 'perfume_notes'; })[0];
      if (notesFacet && notesFacet.values && notesFacet.values.length) {
        notesFacet.values.forEach(function (v) {
          var name = (v.value || "").trim();
          if (name) ingredients[name] = v.count || 0;
        });
      } else {
        var KNOWN_INGREDIENTS = ['tonka','vetiver','vanilla','coconut','lily','patchouli','plum','ylang-ylang','lavendar','lavender','bergamot','leather','musk','caramel','jasmine','sandalwood','amber','oud','cedar','rose'];
        items.forEach(function (p) {
          var tags = p.tags || [];
          if (typeof tags === "string") tags = tags.split(",");
          tags.forEach(function (t) {
            var lower = (t + "").trim().toLowerCase();
            if (KNOWN_INGREDIENTS.indexOf(lower) !== -1) {
              var cap = lower.charAt(0).toUpperCase() + lower.slice(1);
              ingredients[cap] = (ingredients[cap] || 0) + 1;
            }
          });
        });
      }

      if (globalMinPrice === Infinity) globalMinPrice = 0;
      if (globalMaxPrice === 0) globalMaxPrice = 2000;
      PRICE_MIN = Math.floor(globalMinPrice / 10) * 10;
      PRICE_MAX = Math.ceil(globalMaxPrice / 100) * 100;
      if (PRICE_MAX <= PRICE_MIN) PRICE_MAX = PRICE_MIN + 500;

      /* ── Render: Product Type from facets.productTypes ── */
      var catList = document.getElementById("csrf-category-list");
      var catKeys = Object.keys(categories);
      if (catList) {
        catList.innerHTML = catKeys.length
          ? catKeys.map(function (k) {
              return '<label class="csrf-item">' +
                '<input type="checkbox" data-filter="category" value="' + escHtml(k) + '">' +
                '<span>' + escHtml(k) + ' <em>(' + categories[k] + ')</em></span></label>';
            }).join("")
          : '<span class="csrf-empty-msg">No types available</span>';
      }

      /* ── Render: Size pills from variants ── */
      var sizeList = document.getElementById("csrf-size-list");
      var sizeKeys = Object.keys(sizes);
      if (sizeList) {
        sizeList.innerHTML = sizeKeys.length
          ? sizeKeys.map(function (k) {
              return '<button type="button" class="csrf-size-pill" data-filter="size" data-value="' + escHtml(k) + '">' +
                escHtml(k) + '</button>';
            }).join("")
          : '<span class="csrf-empty-msg">No sizes available</span>';
        var sizeSection = document.getElementById("csrf-section-size");
        if (sizeSection) {
          sizeSection.classList.toggle("has-no-sizes", !sizeKeys.length);
        }
        Array.prototype.forEach.call(sizeList.querySelectorAll(".csrf-size-pill"), function (pill) {
          pill.addEventListener("click", function () {
            pill.classList.toggle("is-active");
            self._applyFilters();
          });
        });
      }

      /* ── Render: Gender from tags ── */
      var genderList = document.getElementById("csrf-gender-list");
      var genderKeys = Object.keys(genders);
      var genderSec = document.getElementById("csrf-section-gender");
      if (genderList && genderSec) {
        if (genderKeys.length) {
          genderSec.style.display = "";
          genderList.innerHTML = genderKeys.map(function (k) {
            return '<label class="csrf-item">' +
              '<input type="checkbox" data-filter="gender" value="' + escHtml(k) + '">' +
              '<span>' + escHtml(k) + ' <em>(' + genders[k] + ')</em></span></label>';
          }).join("");
        } else { genderSec.style.display = "none"; }
      }

      /* ── Render: Ingredient from tags ── */
      var ingredientList = document.getElementById("csrf-ingredient-list");
      var ingredientKeys = Object.keys(ingredients);
      var ingredientSec = document.getElementById("csrf-section-ingredient");
      if (ingredientList && ingredientSec) {
        if (ingredientKeys.length) {
          ingredientSec.style.display = "";
          ingredientList.innerHTML = ingredientKeys.map(function (k) {
            return '<label class="csrf-item">' +
              '<input type="checkbox" data-filter="ingredient" value="' + escHtml(k) + '">' +
              '<span>' + escHtml(k) + ' <em>(' + ingredients[k] + ')</em></span></label>';
          }).join("");
        } else { ingredientSec.style.display = "none"; }
      }

      /* ── Render: Availability ── */
      var availList = document.getElementById("csrf-avail-list");
      if (availList) {
        availList.innerHTML =
          '<label class="csrf-item"><input type="checkbox" data-filter="avail" value="in-stock"><span>In Stock <em>(' + availIn + ')</em></span></label>' +
          '<label class="csrf-item"><input type="checkbox" data-filter="avail" value="out-of-stock"><span>Out Of Stock <em>(' + availOut + ')</em></span></label>';
      }

      /* ── Price slider ── */
      var rmin = document.getElementById("csrf-rmin");
      var rmax = document.getElementById("csrf-rmax");
      if (rmin) { rmin.min = PRICE_MIN; rmin.max = PRICE_MAX; rmin.value = PRICE_MIN; }
      if (rmax) { rmax.min = PRICE_MIN; rmax.max = PRICE_MAX; rmax.value = PRICE_MAX; }
      self._updateSlider();

      /* Restore the selections captured at the top so an active filter set
         survives the rebuild. Cards are re-hidden by the _applyFilters() call
         that the render path fires after the grid + stampCards complete. */
      self._restoreState(_prevSel);

      /* ── Store items for card stamping after enrichment ── */
      self._items = items;
    },

    /* ── Stamp data attributes on enriched cards (call after cards render) ── */
    stampCards: function () {
      var items = this._items || [];
      items.forEach(function (p) {
        var handle = (p.handle || "").toLowerCase();
        var cards  = document.querySelectorAll(".csr-card");
        Array.prototype.forEach.call(cards, function (card) {
          if ((card.getAttribute("data-handle") || "").toLowerCase() !== handle) return;
          var pt = (p.productType || p.product_type || "").trim();
          if (pt) card.setAttribute("data-type", pt);
          var variantVals = [];
          (p.variants || []).forEach(function (v) {
            var title = (v.title || "").trim();
            if (title && title.toLowerCase() !== "default title" && title.length <= 40 && variantVals.indexOf(title) === -1) {
              variantVals.push(title); return;
            }
            (v.selectedOptions || []).forEach(function (opt) {
              var val = (opt.value || "").trim();
              if (!val || val.toLowerCase() === "default title" || val.length > 40) return;
              if (variantVals.indexOf(val) === -1) variantVals.push(val);
            });
          });
          if (variantVals.length) card.setAttribute("data-sizes", variantVals.join("|").toLowerCase());
        });
      });
    },

    /* ── Wire up popup events ────────────────────────────────── */
    init: function () {
      if (_initDone) return;
      _initDone = true;
      var self = this;

      /* Filter button click is wired in bootSearchPage directly */

      /* Close button */
      var closeBtn = document.getElementById("csrf-close");
      if (closeBtn) closeBtn.addEventListener("click", function () { self.close(); });

      /* Overlay click */
      var overlay = document.getElementById("csrf-overlay");
      if (overlay) overlay.addEventListener("click", function () { self.close(); });

      /* Price sliders */
      var rmin = document.getElementById("csrf-rmin");
      var rmax = document.getElementById("csrf-rmax");
      function onPriceInput() {
        self._clampSliders();
        self._updateSlider();
      }
      if (rmin) rmin.addEventListener("input", onPriceInput);
      if (rmax) rmax.addEventListener("input", onPriceInput);
      this._updateSlider();

      /* Clear All */
      var clearBtn = document.getElementById("csrf-clear");
      if (clearBtn) clearBtn.addEventListener("click", function () { self._clearAll(); });

      /* Apply */
      var applyBtn = document.getElementById("csrf-apply");
      if (applyBtn) applyBtn.addEventListener("click", function () {
        self._applyFilters();
        self.close();
      });

      /* Escape */
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") self.close();
      });

      /* Click outside to close (desktop only) */
      document.addEventListener("click", function (e) {
        if (window.innerWidth < 750) return;
        var popup = document.getElementById("csrf-popup");
        if (!popup || !popup.classList.contains("is-open")) return;
        var filterBtn = document.getElementById("csr-filter-btn");
        if (popup.contains(e.target) || (filterBtn && filterBtn.contains(e.target))) return;
        self.close();
      });

      /* Auto-apply on checkbox/size change (desktop — no Apply button visible) */
      var popup = document.getElementById("csrf-popup");
      if (popup) {
        popup.addEventListener("change", function(e) {
          if (e.target.matches('input[type="checkbox"]') || e.target.matches('input[type="range"]')) {
            self._applyFilters();
          }
        });
      }
    },

    /* ── Clamp sliders ───────────────────────────────────────── */
    _clampSliders: function () {
      var rmin = document.getElementById("csrf-rmin");
      var rmax = document.getElementById("csrf-rmax");
      if (!rmin || !rmax) return;
      if (parseInt(rmin.value, 10) > parseInt(rmax.value, 10)) {
        rmin.value = rmax.value;
      }
    },

    /* ── Update price slider fill and labels ─────────────────── */
    _updateSlider: function () {
      var rmin  = document.getElementById("csrf-rmin");
      var rmax  = document.getElementById("csrf-rmax");
      var pfill = document.getElementById("csrf-pfill");
      var pvmin = document.getElementById("csrf-pvmin");
      var pvmax = document.getElementById("csrf-pvmax");
      if (!rmin || !rmax) return;

      var range = PRICE_MAX - PRICE_MIN || 1;
      var lo = parseInt(rmin.value, 10);
      var hi = parseInt(rmax.value, 10);
      if (lo > hi) { var tmp = lo; lo = hi; hi = tmp; }

      if (pfill) {
        pfill.style.left  = Math.round((lo - PRICE_MIN) / range * 100) + "%";
        pfill.style.right = Math.round((PRICE_MAX - hi) / range * 100) + "%";
      }
      if (pvmin) pvmin.textContent = "\u20B9" + lo.toLocaleString("en-IN");
      if (pvmax) pvmax.textContent = "\u20B9" + hi.toLocaleString("en-IN");
    },

    /* ── Clear all ────────────────────────────────────────────── */
    _clearAll: function () {
      var popup = document.getElementById("csrf-popup");
      if (popup) {
        var cbs = popup.querySelectorAll("input[type='checkbox']");
        Array.prototype.forEach.call(cbs, function (cb) { cb.checked = false; });
        var pills = popup.querySelectorAll(".csrf-size-pill.is-active");
        Array.prototype.forEach.call(pills, function (p) { p.classList.remove("is-active"); });
      }
      var rmin = document.getElementById("csrf-rmin");
      var rmax = document.getElementById("csrf-rmax");
      if (rmin) rmin.value = PRICE_MIN;
      if (rmax) rmax.value = PRICE_MAX;
      this._updateSlider();
      this._applyFilters();
    },

    /* ── Apply filters client-side on loaded cards ─────────────── */
    _applyFilters: function () {
      var popup = document.getElementById("csrf-popup");
      if (!popup) return;

      var catChecked     = this._getChecked(popup, "category");
      var sizeActive     = this._getActiveSizes();
      var genderChecked  = this._getChecked(popup, "gender");
      var ingredChecked  = this._getChecked(popup, "ingredient");
      var availChecked   = this._getChecked(popup, "avail");

      var rmin     = document.getElementById("csrf-rmin");
      var rmax     = document.getElementById("csrf-rmax");
      var priceMin = rmin ? Math.min(parseInt(rmin.value, 10), parseInt(rmax.value, 10)) : PRICE_MIN;
      var priceMax = rmax ? Math.max(parseInt(rmin.value, 10), parseInt(rmax.value, 10)) : PRICE_MAX;

      var cards = document.querySelectorAll(".csr-card");
      var visibleCount = 0;
      Array.prototype.forEach.call(cards, function (card) {
        var price     = parseFloat(card.getAttribute("data-price") || "0");
        var cardType  = (card.getAttribute("data-type") || "").toLowerCase();
        var cardSizes = (card.getAttribute("data-sizes") || "").toLowerCase();
        var cardTags  = (card.getAttribute("data-tags") || "").toLowerCase();
        var cardAvail = card.getAttribute("data-avail") === "true";

        var catOk = !catChecked.length || catChecked.some(function (c) {
          return cardType === c.toLowerCase();
        });
        var sizeOk = !sizeActive.length || sizeActive.some(function (s) {
          return cardSizes.indexOf(s.toLowerCase()) !== -1;
        });
        var GENDER_MAP = { 'men': ['man','men','perfumes for men','perfume for men'], 'women': ['woman','women','perfumes for her','perfume for women','women fragrances','womens fragrances'], 'unisex': ['unisex','unisex perfumes'] };
        var tagArr = cardTags.split("|");
        var genderOk = !genderChecked.length || genderChecked.some(function (g) {
          var synonyms = GENDER_MAP[g.toLowerCase()] || [g.toLowerCase()];
          return tagArr.some(function(t) { return synonyms.indexOf(t) !== -1; });
        });
        var ingredOk = !ingredChecked.length || ingredChecked.some(function (i) {
          var il = i.toLowerCase();
          return tagArr.some(function(t) { return t === il || t === il + "-filter"; });
        });
        var availOk = !availChecked.length || availChecked.some(function (a) {
          return (a === "in-stock" && cardAvail) || (a === "out-of-stock" && !cardAvail);
        });
        var priceOk = price >= priceMin && price <= priceMax;

        var show = catOk && sizeOk && genderOk && ingredOk && availOk && priceOk;
        card.style.display = show ? "" : "none";
        if (show) visibleCount++;
      });

      /* Update heading count */
      var headingEl = document.getElementById("csr-heading");
      if (headingEl) {
        var h1 = headingEl.querySelector(".csr-title");
        if (h1) {
          var q = (new URLSearchParams(location.search).get("q") || "").trim();
          h1.innerHTML = visibleCount + ' Results found for &ldquo;<strong class="csr-title-query">' + escHtml(q) + '</strong>&rdquo;:';
        }
      }

      this._updatePills(availChecked, catChecked, genderChecked, ingredChecked, sizeActive, priceMin, priceMax);
    },

    /* ── Helpers ──────────────────────────────────────────────── */
    _getChecked: function (popup, filterType) {
      return Array.prototype.map.call(
        popup.querySelectorAll("input[data-filter='" + filterType + "']:checked"),
        function (cb) { return cb.value; }
      );
    },

    _getActiveSizes: function () {
      var pills = document.querySelectorAll(".csrf-size-pill.is-active");
      return Array.prototype.map.call(pills, function (p) { return p.getAttribute("data-value"); });
    },

    /* ── Selection state preservation across populate() rebuilds ── */
    _captureState: function () {
      var popup = document.getElementById("csrf-popup");
      if (!popup) return null;
      var rmin = document.getElementById("csrf-rmin");
      var rmax = document.getElementById("csrf-rmax");
      /* priceTouched is measured against the slider's own current min/max
         attributes (not PRICE_MIN/MAX, which populate is about to overwrite). */
      var priceTouched = !!(rmin && rmax && (
        parseInt(rmin.value, 10) > parseInt(rmin.min, 10) ||
        parseInt(rmax.value, 10) < parseInt(rmax.max, 10)
      ));
      return {
        category:   this._getChecked(popup, "category"),
        gender:     this._getChecked(popup, "gender"),
        ingredient: this._getChecked(popup, "ingredient"),
        avail:      this._getChecked(popup, "avail"),
        sizes:      this._getActiveSizes(),
        priceMin:   rmin ? parseInt(rmin.value, 10) : null,
        priceMax:   rmax ? parseInt(rmax.value, 10) : null,
        priceTouched: priceTouched
      };
    },

    _restoreState: function (st) {
      if (!st) return;
      var popup = document.getElementById("csrf-popup");
      if (!popup) return;

      /* Compare by value in JS to avoid attribute-selector escaping issues. */
      function recheck(type, values) {
        if (!values || !values.length) return;
        Array.prototype.forEach.call(
          popup.querySelectorAll("input[data-filter='" + type + "']"),
          function (cb) { if (values.indexOf(cb.value) !== -1) cb.checked = true; }
        );
      }
      recheck("category", st.category);
      recheck("gender", st.gender);
      recheck("ingredient", st.ingredient);
      recheck("avail", st.avail);

      if (st.sizes && st.sizes.length) {
        Array.prototype.forEach.call(popup.querySelectorAll(".csrf-size-pill"), function (pill) {
          if (st.sizes.indexOf(pill.getAttribute("data-value")) !== -1) pill.classList.add("is-active");
        });
      }

      if (st.priceTouched) {
        var rmin = document.getElementById("csrf-rmin");
        var rmax = document.getElementById("csrf-rmax");
        if (rmin && st.priceMin != null) {
          rmin.value = Math.min(Math.max(st.priceMin, parseInt(rmin.min, 10)), parseInt(rmin.max, 10));
        }
        if (rmax && st.priceMax != null) {
          rmax.value = Math.max(Math.min(st.priceMax, parseInt(rmax.max, 10)), parseInt(rmax.min, 10));
        }
        this._updateSlider();
      }
    },

    /* ── Active filter pills ─────────────────────────────────── */
    _updatePills: function (availChecked, catChecked, genderChecked, ingredChecked, sizeActive, priceMin, priceMax) {
      var pillsWrap = document.getElementById("csr-active-pills");
      if (!pillsWrap) return;
      var self = this;

      var pills = [];
      availChecked.forEach(function (a) {
        pills.push({ label: "Availability : " + (a === "in-stock" ? "In Stock" : "Out of Stock"), key: "avail-" + a });
      });
      catChecked.forEach(function (c) { pills.push({ label: "Product Type : " + c, key: "category-" + c }); });
      /* Gender / Ingredient pills MUST carry their real filter type in the key
         (e.g. "gender-Men") so _removePill can find and uncheck the matching
         input[data-filter='gender']. Previously both were keyed "type-…", which
         pointed at a non-existent data-filter='type' input, so the × did nothing. */
      genderChecked.forEach(function (g) { pills.push({ label: "Gender : " + g, key: "gender-" + g }); });
      ingredChecked.forEach(function (i) { pills.push({ label: "Ingredient : " + i, key: "ingredient-" + i }); });
      sizeActive.forEach(function (s) { pills.push({ label: "Size : " + s, key: "size-" + s }); });
      if (priceMin > PRICE_MIN || priceMax < PRICE_MAX) {
        pills.push({ label: "Price : \u20B9" + priceMin + " \u2013 \u20B9" + priceMax, key: "price" });
      }

      pillsWrap.innerHTML = pills.map(function (p) {
        return '<span class="csr-pill">' + escHtml(p.label) +
          '<span class="csr-pill-x" data-pill-key="' + escHtml(p.key) + '">\u00D7</span>' +
          '</span>';
      }).join("");

      Array.prototype.forEach.call(pillsWrap.querySelectorAll(".csr-pill-x"), function (x) {
        x.addEventListener("click", function () {
          self._removePill(x.getAttribute("data-pill-key"));
        });
      });
    },

    /* ── Remove single filter ─────────────────────────────────── */
    _removePill: function (key) {
      var popup = document.getElementById("csrf-popup");
      if (!popup) return;

      if (key === "price") {
        var rmin = document.getElementById("csrf-rmin");
        var rmax = document.getElementById("csrf-rmax");
        if (rmin) rmin.value = PRICE_MIN;
        if (rmax) rmax.value = PRICE_MAX;
        this._updateSlider();
      } else if (key.indexOf("size-") === 0) {
        var sizeVal = key.slice(5);
        var sizePills = popup.querySelectorAll(".csrf-size-pill");
        Array.prototype.forEach.call(sizePills, function (p) {
          if (p.getAttribute("data-value") === sizeVal) p.classList.remove("is-active");
        });
      } else {
        var parts       = key.split("-");
        var filterType  = parts[0];
        var filterValue = parts.slice(1).join("-");
        var cb = popup.querySelector("input[data-filter='" + filterType + "'][value='" + filterValue + "']");
        if (!cb) {
          Array.prototype.forEach.call(
            popup.querySelectorAll("input[data-filter='" + filterType + "']"),
            function (c) { if (c.value.toLowerCase() === filterValue.toLowerCase()) cb = c; }
          );
        }
        if (cb) cb.checked = false;
      }
      this._applyFilters();
    },

    /* ── Badge count ──────────────────────────────────────────── */
    _updateBadge: function (filterCount, priceMin, priceMax) {
      var badge = document.getElementById("csr-filter-badge");
      if (!badge) return;
      var priceActive = (priceMin > PRICE_MIN || priceMax < PRICE_MAX) ? 1 : 0;
      var total = filterCount + priceActive;
      badge.textContent = total;
      badge.style.display = total > 0 ? "inline-flex" : "none";
    }
  };

})();
